// AnimatedCard.js

import { motion } from 'framer-motion';
import React, { useRef } from 'react';
import use3DHoverEffect from '../Hooks/use3DHover';

const AnimatedCard = () => {
  const cardRef = useRef(null);
  
  const {
    perspective,
    rotateY,
    rotateX,
    scaleImage,
    yPositionImage,
    zPositionImage,
    shadowImage,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
  } = use3DHoverEffect({
    perspectiveRange: [1000, 500],
    rotateRangeX: [25, -25],
    rotateRangeY: [-25, 25],
    scaleRange: [1.3, 1.1],
    depthRange: [0, 30],
  });

  return (
    <motion.div
      className="w-64 h-80 bg-transparent rounded-lg"
      style={{ perspective }}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      ref={cardRef}
    >
      <motion.div
        className="relative w-full h-full rounded-lg bg-white shadow-lg"
        style={{ rotateY, rotateX }}
        drag
        dragConstraints={cardRef}
        dragElastic={0.3}
        whileTap={{ cursor: 'grabbing' }}
      >
        <motion.img
          src="https://images.unsplash.com/photo-1714923495768-f537157f2f19?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Placeholder"
          className="w-5/6 h-1/3 object-cover rounded-t-lg mx-auto"
          style={{
            scale: scaleImage,
            y: yPositionImage,
            z: zPositionImage,
            boxShadow: shadowImage,
            zIndex: 10,
          }}
        />
        <div className="p-4 h-1/3 text-center">
          <h2 className="text-xl font-bold">Card Title</h2>
          <p className="text-gray-700">Some description about the card.</p>
          <motion.button
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded shadow-md"
          >
            Button
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default AnimatedCard;
